import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Button } from "./ui/button";

export function CookieConsent() {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (!localStorage.getItem("bc_consent")) setVisible(true);
    }, []);

    const choose = (value) => {
        localStorage.setItem("bc_consent", value);
        if (value === "yes" && !localStorage.getItem("bc_vid")) {
            localStorage.setItem("bc_vid", crypto.randomUUID());
        }
        setVisible(false);
    };

    return (
        <AnimatePresence>
            {visible && (
                <motion.div
                    initial={{ y: 80, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    exit={{ y: 80, opacity: 0 }}
                    className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-6 sm:max-w-md z-[90] rounded-2xl border border-border bg-white p-5 shadow-xl"
                    data-testid="cookie-consent-banner"
                >
                    <p className="text-sm leading-relaxed text-ink-soft">
                        Nous utilisons un cookie de session indispensable au fonctionnement du site et,{" "}
                        <strong className="text-ink">avec votre accord</strong>, une mesure d'audience anonymisée.
                        Aucune donnée statistique n'est collectée sans votre consentement.{" "}
                        <Link to="/cookies" className="text-gold-dark underline underline-offset-2">
                            En savoir plus
                        </Link>
                    </p>
                    <div className="mt-4 flex gap-3">
                        <Button
                            size="sm"
                            className="bg-forest text-ivory hover:bg-forest-surface font-semibold"
                            onClick={() => choose("yes")}
                            data-testid="cookie-accept-button"
                        >
                            Tout accepter
                        </Button>
                        <Button
                            size="sm"
                            variant="outline"
                            className="border-border text-ink hover:bg-pearl"
                            onClick={() => choose("no")}
                            data-testid="cookie-refuse-button"
                        >
                            Tout refuser
                        </Button>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
}
